export default __webpack_public_path__ + "static/media/discography.3bed8285.svg";